import SelectionLog from "./-selectionLog";
import { selectionLogSearchSchema } from "@/router/staticData";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/goods/selectionLog")({
  staticData: {
    menuLabel: "选品日志",
    showInMenu: true,
    menuGroup: "/goods",
    menuOrder: 1,
  },
  validateSearch: selectionLogSearchSchema,
  component: SelectionLog,
});
